import {
	Context,
	createContext
} from "react";
import { EMPTY_ARRAY } from "client/Misc/utils";
import { outOfContextCall } from "client/Misc/reactUtils";
import { Guid } from "client_legacy/ndaw/guid";
import { HubItemImageRestrictionsModel } from "client/Api/Hub/common";
import { DocumentLocationViewModel } from "client/Api/Hub/hubSettings";

export type BuilderContextData = {
	toolbarContainer: HTMLElement | null;
	setToolbarContainer: (element: HTMLElement | null) => void;
	activeEditorId: Guid | null;
	setActiveEditorId: (id: Guid | null) => void;
	setGetHasChangesHandle: (id: Guid, handle: (() => boolean) | null) => void;
	imageRestrictions: HubItemImageRestrictionsModel;
	defaultImageLocation: DocumentLocationViewModel | null;
	isPixabayImageGalleryAvailable: boolean;
};

export const BuilderContext: Context<BuilderContextData> =
	createContext<BuilderContextData>({
		toolbarContainer: null,
		setToolbarContainer: outOfContextCall("BuilderContext", "setToolbarContainer"),
		activeEditorId: null,
		setActiveEditorId: outOfContextCall("BuilderContext", "setActiveEditorId"),
		setGetHasChangesHandle: outOfContextCall("BuilderContext", "setGetHasChangesHandle"),
		imageRestrictions: {
			maxImageSize: 0,
			supportedFileExtensions: EMPTY_ARRAY,
			supportedMimeTypes: EMPTY_ARRAY
		},
		defaultImageLocation: null,
		isPixabayImageGalleryAvailable: false
	});
